<template>
    <div>
        <div class="card-header">
            <h3 class="mb-0 title--screen">カスタムドメイン設定</h3>
        </div>
        <div class="pt-5 row justify-content-center position-relative">
            <div class="col-sm-6 position-static">
                <div v-if="!checkShowFilter" class="row form-group">
                    <div class="col-sm-12">
                        <KeyWordTag :config="configs.configKeyword" class="flex-fill" />
                    </div>
                </div>
                <template v-else>
                    <div class="form-group row">
                        <label class="col-sm-3">{{ $t('managerForm.email.domain') }}</label>
                        <div class="col-sm-9">
                            <InputText
                                :model.sync="formSearch.domain"
                                :config="{
                                    error: false
                                }"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3">{{ $t('managerForm.list.status') }}</label>
                        <div class="col-sm-9">
                            <div class="d-flex flex-wrap">
                                <div v-for="item in STATUS_DOMAIN" :key="item.value">
                                    <InputRadio
                                        class="mr-3 mb-2"
                                        :model.sync="formSearch.status"
                                        :id="`raido-status_${item.value}`"
                                        :name="`raido-status`"
                                        :value="item.value"
                                        :label="item.label"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="text-center mt-4">
                    <button type="button" @click="clear()" class="btn btn-common btn-outline-primary"><i class="ri-restart-line"></i>クリア</button>
                    <button type="button" @click="search()" class="btn btn-common btn-primary ml-3"><i class="ri-search-line"></i>検索</button>
                    <button type="button" @click="handleShowFilter" class="btn btn-common filter btn-outline-primary" style="bottom: 0">
                        <i class="ri-equalizer-line"></i>絞り込み条件を表示
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-5 mb-2">
            <button type="button" class="btn btn-outline-primary w-25" @click="openModalEdit({}, 'create')">
                <i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>
                新規登録
            </button>
        </div>
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-sm-6">
                    <h3 class="mb-0 title--screen">
                        ドメイン検索結果 <span>件数（{{ configPage.total }})</span>
                    </h3>
                </div>
                <div class="col-sm-6">
                    <div class="text-right">
                        <span class="pagination__items__label mr-4"> {{ configPage.total }} 件中 {{ from }}-{{ to }} 件表示 </span>
                        <span>表示件数</span>
                        <select v-model="configPage.limit" class="pagination__items__select ml-2" @change="onChange">
                            <option v-for="value in perPageList" :key="value" :label="value + '件'" :value="value"></option>
                        </select>
                    </div>
                </div>
            </div>
            <table class="table table-bordered table-list">
                <thead>
                    <th v-for="(item, k) in configs.configTableCustomDomainSetting.headers" :key="k" style="background: #ededed">
                        <div class="d-flex align-items-center">{{ item.label }}</div>
                    </th>
                </thead>
                <tbody v-if="listDomain.length > 0 && !isLoading">
                    <tr v-for="(item, k) in listDomain" :key="k">
                        <td>{{ item.id }}</td>
                        <td>{{ item.domain }}</td>
                        <td>
                            <div class="text-center p-2 rounded" :style="`background-color:${onHandleBgr(item.status)}; color:#ffff; width: 100px`">
                                {{ returnStatus(item.status) }}
                            </div>
                        </td>
                        <td>{{ item.created_at }}</td>
                        <td>
                            <div class="text-left text-nowrap">
                                <a href="javascript:void(0)" class="btn btn-common-sml btn-info mr-2" @click="openModalDetail(item)"
                                    ><i class="ri-file-list-2-line"></i>{{ $t('btn.detail') }}</a
                                >
                                <a href="javascript:void(0)" class="btn btn-common-sml btn-primary mr-2" @click="openModalEdit(item, 'edit')"
                                    ><i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}</a
                                >
                                <a href="javascript:void(0)" class="btn btn-common-sml btn-danger" @click="deleteDomain(item.id)"
                                    ><i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}</a
                                >
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tr v-else-if="isLoading" style="position: relative; height: 80px">
                    <td data-v-2f33a48c="" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border: none">
                        <LoadingIcon />
                    </td>
                </tr>
                <tr v-else style="position: relative; height: 80px">
                    <td data-v-2f33a48c="" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); border: none">
                        <p data-v-2f33a48c="" class="mt-3 text-center">一致する検索結果はありません。</p>
                    </td>
                </tr>
            </table>
            <Pagination
                v-if="configPage.total && listDomain.length > 0 && !isLoading"
                :total="configPage.total"
                :page.sync="configPage.page"
                :per-page="configPage.limit"
                @changePage="handleChangePage"
            ></Pagination>
        </div>

        <ModalCommon
            v-if="configs.configModalDomainDetail.model"
            :id="`ModalDomainDetail`"
            :config="configs.configModalDomainDetail"
            @close="closeModalDomain"
        >
            <template>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group row">
                            <label class="col-sm-3">ID</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.id }}
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">{{ $t('managerForm.email.domain') }}</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.domain }}
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">SSL種類</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.ssl_type === 'CUSTOM' ? '独自証明書利用' : 'AWS証明書利用' }}
                            </div>
                        </div>
                        <div v-if="currentDomain?.cloudfront_hostname" class="form-group row mt-3">
                            <label class="col-sm-3">CloudFrontホスト名</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.cloudfront_hostname }}
                            </div>
                        </div>
                        <div v-if="currentDomain?.ssl_expires_at" class="form-group row mt-3">
                            <label class="col-sm-3">SSL有効期限</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.ssl_expires_at }}
                            </div>
                        </div>
                        <!-- <div v-if="currentDomain?.error_message" class="form-group row mt-3">
                            <label class="col-sm-3 text-danger">エラーメッセージ</label>
                            <div class="col-sm-9 text-danger">
                                {{ currentDomain?.error_message }}
                            </div>
                        </div> -->
                        <table v-if="currentDomain?.dns_record || currentDomain?.acm_validation_record" class="table table-bordered mt-3">
                            <thead>
                                <th></th>
                                <th>Record name</th>
                                <th>Type</th>
                                <th>Value</th>
                            </thead>
                            <tbody>
                                <tr v-if="currentDomain?.dns_record">
                                    <td>DNS</td>
                                    <td>
                                        <a
                                            href="javascript:void(0)"
                                            @click="copyToClipboard(`${currentDomain?.dns_record?.record_name}`)"
                                            class="mr-2"
                                            ><i class="fa fa-clone text-primary" aria-hidden="true"></i></a
                                        >{{ currentDomain?.dns_record?.record_name }}
                                    </td>
                                    <td>{{ currentDomain?.dns_record?.type }}</td>
                                    <td class="d-flex">
                                        <a href="javascript:void(0)" @click="copyToClipboard(`${currentDomain?.dns_record?.value}`)" class="mr-2"
                                            ><i class="fa fa-clone text-primary" aria-hidden="true"></i></a
                                        >{{ currentDomain?.dns_record?.value }}
                                    </td>
                                </tr>
                                <tr v-if="currentDomain?.acm_validation_record">
                                    <td>SSL</td>
                                    <td>
                                        <a
                                            href="javascript:void(0)"
                                            @click="copyToClipboard(`${currentDomain?.acm_validation_record?.name}`)"
                                            class="mr-2"
                                            ><i class="fa fa-clone text-primary" aria-hidden="true"></i></a
                                        >{{ currentDomain?.acm_validation_record?.name }}
                                    </td>
                                    <td>{{ currentDomain?.acm_validation_record?.type }}</td>
                                    <td class="d-flex">
                                        <a
                                            href="javascript:void(0)"
                                            @click="copyToClipboard(`${currentDomain?.acm_validation_record?.value}`)"
                                            class="mr-2"
                                            ><i class="fa fa-clone text-primary" aria-hidden="true"></i></a
                                        >{{ currentDomain?.acm_validation_record?.value }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">作成日</label>
                            <div class="col-sm-9">
                                {{ currentDomain?.created_at }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="d-flex align-items-center justify-content-center">
                <button type="button" class="btn btn-light" @click="() => (configs.configModalDomainDetail.model = false)">
                    {{ $t('btn.cancel') }}
                </button>
            </div>
        </ModalCommon>
        <ModalCommon
            v-if="configs.configModalDomainEdit.model"
            :id="`ModalDomainEdit`"
            :config="configs.configModalDomainEdit"
            @close="closeModalDomain"
            @save="handleUpdateDomain"
        >
            <template>
                <div class="card">
                    <div class="card-body">
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">{{ $t('managerForm.email.domain') }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="currentDomain.domain"
                                    :config.sync="configFormDomain.configFieldDomain"
                                    @blur="validateField(configFormDomain.configFieldDomain)"
                                />
                            </div>
                        </div>
                        <div class="form-group row mt-3">
                            <label class="col-sm-3">SSL種類 <span class="text-danger">*</span></label>
                            <div class="col-sm-9 d-flex align-items-center">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="configFormDomain.configFieldSslType.valueSync"
                                    id="ssl_type_aws"
                                    name="ssl_type"
                                    value="AWS"
                                    label="AWS証明書利用"
                                />
                                <InputRadio
                                    :model.sync="configFormDomain.configFieldSslType.valueSync"
                                    id="ssl_type_custom"
                                    name="ssl_type"
                                    value="CUSTOM"
                                    label="独自証明書利用"
                                />
                            </div>
                        </div>
                        <template v-if="configFormDomain.configFieldSslType.valueSync === 'CUSTOM'">
                            <div class="form-group row mt-3">
                                <label class="col-sm-3">証明書</label>
                                <div class="col-sm-9">
                                    <UploadFile
                                        typeUpload="import"
                                        id="certificate_file"
                                        classLabel="btn-primary"
                                        title=" ファイルアップロード"
                                        :fileValues.sync="configFormDomain.configFieldCertificateFile.valueSync"
                                        :config="{ allowedSize: 10240, multiple: false, allowedExtension: ['pem', 'crt', 'cer', 'txt'] }"
                                        @importFile="
                                            (file) => {
                                                rawFiles.certificate_file = file;
                                                configFormDomain.configFieldCertificateFile.error = false;
                                            }
                                        "
                                        @removeFile="
                                            () => {
                                                rawFiles.certificate_file = null;
                                                configFormDomain.configFieldCertificateFile.valueSync = null;
                                            }
                                        "
                                    />
                                    <div class="text-muted mt-1" style="font-size: 12px">※ 対応形式: .pem, .crt, .cer, .txt</div>
                                    <div v-if="configFormDomain.configFieldCertificateFile.error" class="invalid-feedback d-block">
                                        {{ configFormDomain.configFieldCertificateFile.errorCustomMess }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row mt-3">
                                <label class="col-sm-3">秘密鍵</label>
                                <div class="col-sm-9">
                                    <UploadFile
                                        typeUpload="import"
                                        id="private_key_file"
                                        classLabel="btn-primary"
                                        title=" ファイルアップロード"
                                        :fileValues.sync="configFormDomain.configFieldPrivateKeyFile.valueSync"
                                        :config="{ allowedSize: 10240, multiple: false, allowedExtension: ['pem', 'key', 'txt'] }"
                                        @importFile="
                                            (file) => {
                                                rawFiles.private_key_file = file;
                                                configFormDomain.configFieldPrivateKeyFile.error = false;
                                            }
                                        "
                                        @removeFile="
                                            () => {
                                                rawFiles.private_key_file = null;
                                                configFormDomain.configFieldPrivateKeyFile.valueSync = null;
                                            }
                                        "
                                    />
                                    <div class="text-muted mt-1" style="font-size: 12px">※ 対応形式: .pem, .key, .txt</div>
                                    <div v-if="configFormDomain.configFieldPrivateKeyFile.error" class="invalid-feedback d-block">
                                        {{ configFormDomain.configFieldPrivateKeyFile.errorCustomMess }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row mt-3">
                                <label class="col-sm-3">証明書チェーン</label>
                                <div class="col-sm-9">
                                    <UploadFile
                                        typeUpload="import"
                                        id="certificate_chain_file"
                                        classLabel="btn-primary"
                                        title=" ファイルアップロード"
                                        :fileValues.sync="configFormDomain.configFieldCertificateChainFile.valueSync"
                                        :config="{ allowedSize: 10240, multiple: false, allowedExtension: ['pem', 'crt', 'cer', 'ca-bundle', 'txt'] }"
                                        @importFile="
                                            (file) => {
                                                rawFiles.certificate_chain_file = file;
                                            }
                                        "
                                        @removeFile="
                                            () => {
                                                rawFiles.certificate_chain_file = null;
                                                configFormDomain.configFieldCertificateChainFile.valueSync = null;
                                            }
                                        "
                                    />
                                    <div class="text-muted mt-1" style="font-size: 12px">※ 対応形式: .pem, .crt, .cer, .ca-bundle, .txt</div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </ModalCommon>
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import { managerFormMethods } from '@/state/helpers';
import ModalCommon from '@/components/Modal/main.vue';
import { onHandleShowConfirm } from '@/utils/handlers';
import { validateAllField, validateField } from '@/utils/validate';
import { showMessage } from '@/utils/messages';
import { configFormCustomDomain, configs, STATUS_DOMAIN, initFormSearch } from '../../constants';
import _ from 'lodash';
import KeyWordTag from '@/components/KeywordTag/main.vue';
import Pagination from '@/components/Pagination/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import UploadFile from '@/components/Uploads/Files/main.vue';

export default {
    name: 'CustomDomainEmail',
    components: {
        ModalCommon,
        InputText,
        KeyWordTag,
        InputRadio,
        Pagination,
        LoadingIcon,
        UploadFile
    },
    data() {
        return {
            configFormDomain: configFormCustomDomain(),
            configs,
            configPage: configs.configPage,
            listDomain: [],
            currentDomain: {
                domain: ''
            },
            checkShowFilter: false,
            formSearch: initFormSearch(),
            STATUS_DOMAIN: STATUS_DOMAIN,
            isLoading: false,
            perPageList: [10, 30, 50],
            rawFiles: {
                certificate_file: null,
                private_key_file: null,
                certificate_chain_file: null
            }
        };
    },
    computed: {
        from: function () {
            return (this.configPage.page - 1) * this.configPage.limit + 1;
        },
        to: function () {
            let to = this.configPage.page * this.configPage.limit;
            return to > this.configPage.total ? this.configPage.total : to;
        }
    },
    methods: {
        ...managerFormMethods,
        validateField,
        validateAllField,
        handleShowFilter() {
            this.checkShowFilter = !this.checkShowFilter;
        },
        handleChangePage() {
            this.onGetListCustomDomain();
        },
        onHandleBgr(objb) {
            const foundStt = STATUS_DOMAIN.find((item) => item.value === objb);
            return foundStt?.backgroundColor;
        },
        returnStatus(objb) {
            const foundStt = STATUS_DOMAIN.find((item) => item.value === objb);
            return foundStt?.label;
        },
        async onGetListCustomDomain() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const dataRes = await this.getListCustomDomain(query);
                this.listDomain = dataRes.data;
                this.configPage.total = dataRes._metadata.total;
                this.configPage.limit = dataRes._metadata.limit * 1;
                if (!this.listDomain.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.onGetListCustomDomain();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            }
        },
        initDomain() {
            return {
                domain: ''
            };
        },
        openModalDetail(item) {
            this.currentDomain = item;
            this.configs.configModalDomainDetail.model = true;
        },
        resetModalDomain() {
            this.currentDomain = this.initDomain();
            this.configFormDomain = configFormCustomDomain();
            this.rawFiles = {
                certificate_file: null,
                private_key_file: null,
                certificate_chain_file: null
            };
        },
        openModalEdit(item, action) {
            this.configs.configModalDomainEdit.model = true;
            if (action === 'edit') {
                this.configs.configModalDomainEdit.title = this.$t('btn.edit');
                this.currentDomain = _.cloneDeep(item);
                this.configFormDomain.configFieldSslType.valueSync = this.currentDomain.ssl_type || 'AWS';
                if (this.currentDomain.certificate_file) {
                    this.configFormDomain.configFieldCertificateFile.valueSync = this.currentDomain.certificate_file;
                }
                if (this.currentDomain.private_key_file) {
                    this.configFormDomain.configFieldPrivateKeyFile.valueSync = this.currentDomain.private_key_file;
                }
                if (this.currentDomain.certificate_chain_file) {
                    this.configFormDomain.configFieldCertificateChainFile.valueSync = this.currentDomain.certificate_chain_file;
                }
            } else {
                this.configs.configModalDomainEdit.title = '作成';
            }
        },
        closeModalDomain() {
            this.configs.configModalDomainDetail.model = false;
            this.configs.configModalDomainEdit.model = false;
            this.resetModalDomain();
        },
        async handleUpdateDomain() {
            let check = validateAllField(this.configFormDomain);
            if (!check) return;
            const formData = new FormData();
            formData.append('domain', this.currentDomain.domain);
            formData.append('ssl_type', this.configFormDomain.configFieldSslType.valueSync);
            if (this.configFormDomain.configFieldSslType.valueSync === 'CUSTOM') {
                if (this.rawFiles.certificate_file) {
                    formData.append('certificate_file', this.rawFiles.certificate_file);
                } else if (!this.configFormDomain.configFieldCertificateFile.valueSync) {
                    formData.append('certificate_file', '');
                }
                if (this.rawFiles.private_key_file) {
                    formData.append('private_key_file', this.rawFiles.private_key_file);
                } else if (!this.configFormDomain.configFieldPrivateKeyFile.valueSync) {
                    formData.append('private_key_file', '');
                }
                if (this.rawFiles.certificate_chain_file) {
                    formData.append('certificate_chain_file', this.rawFiles.certificate_chain_file);
                } else if (!this.configFormDomain.configFieldCertificateChainFile.valueSync) {
                    formData.append('certificate_chain_file', '');
                }
            }
            const payload = {
                id: this.currentDomain.id,
                data: formData
            };
            try {
                let dataRes;
                if (this.configs.configModalDomainEdit.title === '作成') {
                    dataRes = await this.registerCustomDomain(payload.data);
                } else {
                    dataRes = await this.updateCustomDomain(payload);
                }
                if (dataRes.code == 200) {
                    this.configs.configModalDomainEdit.model = false;
                    if (this.configs.configModalDomainEdit.title === '作成') {
                        showMessage(dataRes.code, this.$bvToast, this.$t('managerForm.email.registDomainSuccess'));
                    } else {
                        showMessage(dataRes.code, this.$bvToast, this.$t('managerForm.email.updateDomainSuccess'));
                    }
                    this.resetModalDomain();
                    this.onGetListCustomDomain();
                } else {
                    if (dataRes.message === 'domain.unique') {
                        showMessage(dataRes.code, this.$bvToast, this.$t('managerForm.email.domainUnique'));
                    } else {
                        showMessage(dataRes.code, this.$bvToast, this.$t(dataRes.message));
                    }
                }
            } catch (error) {
                console.log('error', error);
            }
        },
        async copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
                showMessage(200, this.$bvToast, 'クリップボードにコピーしました。');
            } catch (err) {
                console.error('Failed to copy text:', err);
            }
        },
        async deleteDomain(id) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'このドメインを削除してもよろしいですか。',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                cancelButtonText: 'キャンセル',
                confirmButtonText: 'OK'
            });
            if (confirmDelete) {
                try {
                    const response = await this.deleteCustomDomain(id);
                    if (response.code !== 200) return;
                    showMessage(response.code, this.$bvToast, 'ドメインが削除されました。');
                    this.resetModalDomain();
                    this.onGetListCustomDomain();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        clear() {
            this.configs.configKeyword.arrayTag = [];
            this.formSearch = initFormSearch();
            this.onGetListCustomDomain();
        },
        search() {
            this.onGetListCustomDomain();
        },
        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=desc`];
            let copyForm = Object.assign({}, this.formSearch);

            if (copyForm) {
                if (!this.checkShowFilter) {
                    if (this.configs.configKeyword.arrayTag.length > 0) query.push(`q=${this.configs.configKeyword.arrayTag.toString()}`);
                } else {
                    for (const [key, value] of Object.entries(copyForm)) {
                        if (key == 'domain') {
                            if (key && value) query.push(`search[${key}]=${value}`);
                        }
                        if (key == 'status') {
                            if (key && value) query.push(`filters[${key}]=${value}`);
                        }
                    }
                }
            }
            return query.join('&');
        },
        onChange() {
            this.configPage.page = 1;
            this.onGetListCustomDomain();
        }
    },
    async mounted() {
        await this.onGetListCustomDomain();
    }
};
</script>

<style lang="scss" scoped>
.table-list td {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
